import { memo } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

interface PriceDiscountDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const PriceDiscountDialog = memo(({ open, onOpenChange }: PriceDiscountDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideCloseButton
        className="w-[90%] max-w-[680px] max-h-[85vh] bg-base rounded-[12px] shadow-[0_8px_32px_rgba(0,0,0,0.15)] p-0 overflow-hidden flex flex-col gap-0"
      >
        <div className="relative bg-[linear-gradient(135deg,#e85d75_0%,#f48fb1_50%,#ffb4a2_100%)] p-[20px]">
          <div className="inline-flex items-center gap-sm bg-white/20 px-md py-sm rounded-[10px] text-sm font-medium text-invert mb-[10px]">
            <span>🔥</span>
            <span>重要通知</span>
          </div>
          <DialogTitle className="text-invert text-lg font-semibold leading-[1.4]">
            模型升级调价通知
          </DialogTitle>
          <button
            onClick={() => onOpenChange(false)}
            className="absolute top-[14px] right-[14px] w-[26px] h-[26px] rounded-full bg-white/20 border-none text-invert cursor-pointer flex items-center justify-center text-xl transition-all hover:bg-white/30"
          >
            ×
          </button>
        </div>

        <div className="flex-1 min-h-0 p-[20px] overflow-y-auto">
          <div className="text-center mb-lg">
            <h3 className="text-md font-semibold text-01 mb-sm">计费方式重大升级</h3>
            <p className="text-03 text-sm">来鼓与模型供应商达成合作，现推出分级计费模式</p>
          </div>

          <div className="grid grid-cols-[1fr_auto_1fr] gap-[12px] mb-[20px] items-center">
            <div className="rounded p-[12px] bg-[#fafafa] border border-[#e0e0e0] relative">
              <div className="absolute top-[-9px] left-[10px] bg-[#999] text-invert px-md py-[2px] rounded text-[10px] font-medium">
                旧版计费
              </div>
              <div className="py-[8px] border-black/5">
                <div className="text-xs text-03 mb-[3px]">计费模式</div>
                <div className="text-md font-medium text-03 line-through opacity-50">统一收费</div>
              </div>
            </div>

            <div className="text-3xl text-[#ff2442] text-center">→</div>

            <div className="rounded p-[12px] bg-[#fff5f7] border border-[#ffccd5] relative">
              <div className="absolute top-[-9px] left-[10px] bg-[#ff2442] text-invert px-md py-[2px] rounded text-[10px] font-medium">
                新版计费
              </div>
              <div className="py-[8px] border-black/5">
                <div className="text-xs text-03 mb-[3px]">计费模式</div>
                <div className="text-lg font-medium text-[#ff2442]">分级计费</div>
              </div>
            </div>
          </div>

          <div className="mt-[20px]">
            <h3 className="text-[13px] font-semibold text-01 mb-[10px] text-center">
              三种接待模式定价详情
            </h3>

            <div className="grid grid-cols-3 gap-[10px]">
              <div className="bg-base border border-[#e8e8e8] rounded p-[12px] text-center transition-all hover:border-[#d0d0d0]">
                <div className="text-3xl mb-md">👤</div>
                <h4 className="text-[13px] font-semibold text-01 mb-sm">人工接待</h4>
                <p className="text-03 text-xs mb-[10px] leading-[1.4]">客服人员手动回复</p>
                <div className="pt-[10px] border-t border-[#f5f5f5]">
                  <div className="flex justify-between items-center mb-[5px] text-xs">
                    <span className="text-03">获取留资</span>
                    <span className="text-[#52c41a] font-medium text-sm">免费</span>
                  </div>
                  <div className="flex justify-between items-center text-xs">
                    <span className="text-03">用户开口</span>
                    <span className="text-[#52c41a] font-medium text-sm">免费</span>
                  </div>
                </div>
              </div>

              <div className="bg-base border border-[#e8e8e8] rounded p-[12px] text-center transition-all hover:border-[#d0d0d0]">
                <div className="text-3xl mb-md">⚙️</div>
                <h4 className="text-[13px] font-semibold text-01 mb-sm">工作流接待</h4>
                <p className="text-03 text-xs mb-[10px] leading-[1.4]">自动化流程响应</p>
                <div className="pt-[10px] border-t border-[#f5f5f5]">
                  <div className="flex justify-between items-center mb-[5px] text-xs">
                    <span className="text-03">获取留资</span>
                    <span className="text-[#ff2442] font-medium text-sm">8 点</span>
                  </div>
                  <div className="flex justify-between items-center text-xs">
                    <span className="text-03">用户开口</span>
                    <span className="text-[#ff2442] font-medium text-sm">4 点</span>
                  </div>
                </div>
              </div>

              <div className="bg-[#fff8f9] border border-[#ff2442] rounded p-[12px] text-center transition-all relative">
                <div className="absolute top-[-7px] right-[8px] bg-[#ff2442] text-invert px-[7px] py-[2px] rounded text-[9px] font-medium">
                  最智能
                </div>
                <div className="text-3xl mb-md">🤖</div>
                <h4 className="text-[13px] font-semibold text-01 mb-sm">AI 接待</h4>
                <p className="text-03 text-xs mb-[10px] leading-[1.4]">智能AI对话引擎</p>
                <div className="pt-[10px] border-t border-[#f5f5f5]">
                  <div className="flex justify-between items-center mb-[5px] text-xs">
                    <span className="text-03">获取留资</span>
                    <span className="text-[#ff2442] font-medium text-sm">20 点</span>
                  </div>
                  <div className="flex justify-between items-center text-xs">
                    <span className="text-03">用户开口</span>
                    <span className="text-[#ff2442] font-medium text-sm">10 点</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#fff5f7] border-l-[2px] border-[#ff2442] rounded p-[12px] mt-lg">
            <div className="flex items-center gap-sm text-2xl font-semibold text-01 mb-md">
              <span>✨</span>
              <span>品质保证</span>
            </div>
            <ul className="list-none p-0 space-y-0">
              <li className="text-xs text-03 leading-[1.6] pl-lg relative">
                <span className="absolute left-0 text-[#52c41a]">✓</span>
                AI模型效果完全不变，质量有保障
              </li>
              <li className="text-xs text-03 leading-[1.6] pl-lg relative">
                <span className="absolute left-0 text-[#52c41a]">✓</span>
                技术持续升级优化中，体验更佳
              </li>
              <li className="text-xs text-03 leading-[1.6] pl-lg relative">
                <span className="absolute left-0 text-[#52c41a]">✓</span>
                新价格立即生效，无需任何操作
              </li>
              <li className="text-xs text-03 leading-[1.6] pl-lg relative">
                <span className="absolute left-0 text-[#52c41a]">✓</span>
                根据实际接待方式自动计费，更加合理
              </li>
            </ul>
          </div>
        </div>

        <div className="p-[20px] pt-0 text-center">
          <button
            className="bg-[#ff2442] text-invert border-none rounded-[6px] px-xl py-[9px] text-[13px] font-medium cursor-pointer transition-all hover:bg-[#e6203b]"
            onClick={() => onOpenChange(false)}
          >
            确定
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
});

PriceDiscountDialog.displayName = 'PriceDiscountDialog';

export default PriceDiscountDialog;
